import { TranslationsService } from './TranslationsService';
import { Init } from './models';

let translationsService: TranslationsService | undefined = undefined;

export const translationsServiceInit = ({ debug }: Init) => {
  translationsService = new TranslationsService({ debug });
  return translationsService;
};

export { translationsService };
